import $ from 'jquery';

export default class BlockQuickNavigation {
  init () {
    $('.block-quick-navigation').on('click', '.dropdown-menu a', event => {
      event.preventDefault();
      const self = $(event.currentTarget);
      const elm = $(self[0].hash);

      if (elm.length) {
        const scrollTop = elm.offset().top - 150;
        // Scroll to target
        $('html, body').animate({
          scrollTop,
        }, 500);
      }
    });
  }
}
